module.exports = __webpack_public_path__ + "img/arroba.46909596.png";